import React from "react";
import cn from 'classnames'
import styles from './confrimBox.module.scss'

function ConfrimBox(props){
    const closeP = () => {
        props.closePopu(false)
    }
    const confirm=()=>{
        props.confirmOk(true)
    }
    return(
        <div className={cn(styles.addPopup)}>
            <div className={cn(styles.addInnerPopup)}>
            <div className={cn(styles.popupHeader)}>
                    <img className={cn(styles.popup_Close)} src={require('assets/close.png').default} alt="Rectangle 36" onClick={() => closeP()} />
                    <h1 className={cn(styles.popupTitle)}>
                       Schedule
                    </h1>
                </div>
                <div className={cn(styles.container)}>
                    <span>Are you sure post api data?</span>
                </div>
                <div className={cn(styles.footer)}>
                <div className={cn(styles.textRight)}>
                            <button className={cn(styles.btnCancel)} onClick={() => closeP()}>Cancel</button>
                            <button className={cn(styles.btnOk)}  onClick={() => confirm()}>Yes</button>
                        </div>
                </div>
            </div>
        </div>
    )
}
export default ConfrimBox